'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'Which is the trusted Marathi CKP matrimony in Maharashtra?', answer: 'MarathiVadhuVarSuchak.com is the trusted Marathi CKP matrimony in Maharashtra.' },
  { question: 'How to search CKP grooms Thane based profiles?', answer: 'Marathi CKP brides can visit MarathiVadhuVarSuchak.com for free registration. Here you can Thane region based Marathi CKP grooms.' },
  { question: 'How to search CKP grooms USA based profiles?', answer: 'Visit MarathiVadhuVarSuchak.com Marathi matrimony site to search USA based CKP grooms profiles.' },
  { question: 'How to search CKP grooms Mumbai based profiles?', answer: 'Marathi CKP brides can visit MarathiVadhuVarSuchak.com matrimony site for free registration to search Mumbai based CKP grooms profiles.' },
  { question: 'How to search CKP grooms Australia based profiles?', answer: 'Marathi CKP brides can visit MarathiVadhuVarSuchak.com site to register free. Then you can search Australia based CKP grooms profiles.' },
  { question: 'How to search CKP grooms Canada based profiles?', answer: 'Marathi CKP brides can visit MarathiVadhuVarSuchak.com matrimonial site to register free. Then brides can search Canada based CKP grooms profiles.' },
  { question: 'How to search CKP brides Mumbai based profiles?', answer: 'Marathi CKP grooms can visit MarathiVadhuVarSuchak.com matrimony site for free registration. Then grooms can search Mumbai based CKP brides profiles.' },
  { question: 'How to search CKP Brides Thane location profiles?', answer: 'Marathi CKP grooms can visit MarathiVadhuVarSuchak.com portal for free registration. Then grooms can search Thane region based CKP brides profiles.' },
  { question: 'How to search CKP Brides Pune based profiles?', answer: "Marathi CKP grooms can need to register free through MarathiVadhuVarSuchak.com matrimony. After approval you can search Pune based CKP bride's profiles." },
  { question: 'How to search CKP Matrimony Thane location profiles?', answer: 'To search Thane based Marathi CKP grooms and brides you have to register free on MarathiVadhuVarSuchak.com matrimonial site.' },
  { question: 'How to search CKP Matrimony Marathi grooms and brides profiles?', answer: 'To search CKP Matrimony Marathi grooms and brides profiles, you have to register free through MarathiVadhuVarSuchak.com matrimony site.' },
  { question: 'How to search Marathi CKP Caste grooms and brides?', answer: 'To search Marathi CKP Caste grooms and brides, you can register on MarathiVadhuVarSuchak.com matrimony portal.' },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "CKP grooms" },
  { label: "CKP grooms Thane" },
  { label: "CKP grooms USA" },
  { label: "CKP grooms Mumbai" },
  { label: "CKP grooms Australia" },
  { label: "CKP grooms Canada" },
  { label: "CKP Brides" },
  { label: "CKP brides Mumbai" },
  { label: "CKP Brides Thane" },
  { label: "CKP Brides Pune" },
  { label: "CKP Matrimony login" },
  { label: "CKP Matrimony Thane" },
  { label: "CKP matrimony brides" },
  { label: "CKP Matrimony grooms" },
  { label: "CKP Matrimony USA" },
  { label: "CKP Matrimony Dadar" },
  { label: "CKP Matrimony - Thane" },
  { label: "CKP Matrimony Marathi" },
  { label: "CKP Matrimony sites" },
  { label: "CKP Matrimony Pune" },
  { label: "CKP Matrimony Mumbai" },
  { label: "CKP Vadhu Var Suchak Mandal Thane" },
  { label: "CKP Vadhu Var Suchak Mandal" },
  { label: "Marathi CKP caste" },
  { label: "CKP Caste in Marathi" },
  { label: "CKP caste Marathi" },
  { label: "CKP caste surnames" },
  { label: "CKP caste population in Maharashtra" },
  { label: "CKP caste history in Marathi" },
  { label: "CKP caste origin" },
  { label: "CKP caste Maratha" },
  { label: "CKP caste l" },
  { label: "CKP caste information in Marathi" },
  { label: "Marathi CKP Caste" },
];

export default function MarathiCKPMatrimonyClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठी सीकेपी वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="marathi_ckp_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="CKP Matrimony for Marathi CKP Communities"
        items={communityServices}
      />

    </div>
  );
}
